import { configureStore } from '@reduxjs/toolkit'
import authReducer from './slices/authSlice'
import uiReducer from './slices/uiSlice'
import activitiesReducer from './slices/activitiesSlice'
import notificationsReducer from './slices/notificationsSlice'
import wherebyReducer from './slices/wherebySlice'
import inAppNotificationsReducer from './slices/inAppNotificationsSlice'
import { wherebyPersistMiddleware } from './middleware/wherebyPersistMiddleware'

export const store = configureStore({
  reducer: {
    auth: authReducer,
    ui: uiReducer,
    activities: activitiesReducer,
    notifications: notificationsReducer,
    whereby: wherebyReducer,
    inAppNotifications: inAppNotificationsReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'auth/setFirebaseUser'],
        ignoredPaths: ['activities.notifiedActivityIds', 'auth.firebaseUser']
      }
    }).concat(wherebyPersistMiddleware)
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
export type AppStore = typeof store
